<div class="c-page-emloyeeconfirm"> 
    <div class="container">
      <div class="row mobile--orange u-pt30 u-pb30">
        <div class="col-md-12" *ngIf="type">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a [routerLink]="['/']"  > {{'AccessRequestConfirmationPortal.home'| translate}} </a></li>
              <li class="breadcrumb-item active" aria-current="page">&nbsp;-<span> {{'AccessRequestConfirmationPortal.location'| translate}} </span></li>
            </ol>
          </nav>
          <h2 class="o-title" *ngIf="type.id == 1" >{{'AccessRequestConfirmationPortal.employee' | translate }}</h2>
          <h2 class="o-title" *ngIf="type.id == 2" >{{'AccessRequestConfirmationPortal.contractor' | translate }} </h2>  
          <h2 class="o-title" *ngIf="type.id == 3" >{{'AccessRequestConfirmationPortal.visitors' | translate }}   </h2>  
          <h2 class="o-title" *ngIf="type.id == 4" >{{'AccessRequestConfirmationPortal.exception' | translate }}  </h2>            
        
        </div>
      </div>
    </div>
    <section class="c-results">
      <div class="container u-pt40">
        <div class="row" *ngIf="type">
          <div class="col-md-10 col-md-offset-1">
            <h2 class="o-title o-title--medium o-title--center js-txt4">{{'AccessRequestConfirmationPortal.title' | translate}}</h2>
            <div class="o-steps">
              <div class="row">
                <div class="col-md-12">
                  <!-- Normal flow -->
                  <div class="row" *ngIf="!items.facilityApproverId && !(status.id==12 || status.id==13 || type.id ==3)" >

                      <div class="col-md-offset-1 col-xs-5 o-steps__step o-steps__step--approved">
                        <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                        <label class="js-txt5">{{'AccessRequestConfirmationPortal.step1' | translate}}</label>
                        <p class="js-txt6">{{'AccessRequestConfirmationPortal.submitRequest' | translate}}</p>
                      </div>
                   
                      <div class="col-xs-5 o-steps__step" *ngIf="status.id===1">
                        <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                        <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                        <p>{{'AccessRequestConfirmationPortal.statusReviewApprover' | translate}} </p>
                    </div>

                    <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="status.id===3">
                        <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                        <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                        <p>{{'AccessRequestConfirmationPortal.statusReject' | translate}}  </p>
                    </div>
                    <div class="col-xs-5 o-steps__step o-steps__step--approved" *ngIf="status.id===2">
                        <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                        <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                        <p> {{'AccessRequestConfirmationPortal.statusClosed' | translate}} </p>
                    </div>

                  </div>


                  <!-- visitor FLOW -->
                  <div class="row" *ngIf="!items.facilityApproverId && (status.id==12 || status.id==13 || type.id ==3)">

                    <div class="col-md-offset-1 col-xs-2 o-steps__step o-steps__step--approved">
                        <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                        <label class="js-txt5">{{ 'AccessRequestConfirmationPortal.step1' | translate}}</label>
                        <p class="js-txt6">{{'AccessRequestConfirmationPortal.submitRequest' | translate}}</p>
                      </div>
                    <!-- 2nd circle  -->
                    <!-- <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="status.id===13">
                        <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                        <label>{{'steps.step2' | translate}}</label>
                        <p>{{'accessEmployeeDetail.status-terminated-text' | translate}} </p>
                    </div> -->
                    <div class="col-xs-5  o-steps__step o-steps__step--approved" >
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.visitorComplete' | translate}}  </p>
                    </div>
  
  
                    <!-- <div class="col-xs-5  o-steps__step" *ngIf="status.id===12">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label>{{'steps.step2' | translate}}</label>
                      <p> {{'AccessRequestConfirmationPortal.statusPendingVisitorForms' | translate}}</p>
                    </div> -->
  
                    <!-- 3rd circle  -->
                    <div class="col-xs-2 o-steps__step" *ngIf="status.id===12 || status.id===1">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label class="js-txt5">{{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusReviewApprover' | translate}}</p>
                    </div>
                    <!-- <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===13">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label> {{'steps.step3' | translate}}</label>
                      <p>{{'accessEmployeeDetail.status-terminated-text' | translate}}</p>
                    </div> -->
  
                    <div class="col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id===2 ">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusClosed' | translate}} </p>
                  </div>
  
                  <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===3 ">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label> {{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusReject' | translate}}</p>
                  </div>
  
                </div>





                  <div class="row" *ngIf="items.facilityApproverId">

                    <div class="col-md-offset-1 col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id!=10 && status.id!=9" >
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label class="js-txt5">{{'AccessRequestConfirmationPortal.step1' | translate}}</label>
                      <p class="js-txt6">{{'AccessRequestConfirmationPortal.submitRequest' | translate}}</p>
                    </div>

                    <div class="col-md-offset-1 col-xs-2 o-steps__step o-steps__step--approved"  *ngIf="status.id===10 || status.id===9">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label class="js-txt5">{{'AccessRequestConfirmationPortal.step1' | translate}}</label>
                      <p class="js-txt6">{{'AccessRequestConfirmationPortal.submitRequest' | translate}}</p>
                    </div>
                    
                    <!-- 2° circle Facility -->
                    <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===5 && items.facilityPriority===true">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusApprovedPropWork' | translate}} </p>
                    </div>
                    <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="status.id===11">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusTerminate' | translate}}  </p>
                    </div>
                    <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===7 && items.facilityPriority===true">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusApprovedPropWork' | translate}} </p>
                    </div>
                    <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===6 && items.facilityPriority===false">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusApprovedApprover' | translate}} </p>
                    </div>
                    <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===8 && items.facilityPriority===false">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusApprovedApprover' | translate}} </p>
                    </div>
                    <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===8 && items.facilityPriority===true">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusApprovedApprover' | translate}} </p>
                    </div>

                    <div class="col-xs-5  o-steps__step o-steps__step--rejected" *ngIf="status.id===10 && items.facilityPriority===true">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusRejectedPropWork' | translate}}</p>
                    </div>

                    <div class="col-xs-5  o-steps__step o-steps__step--rejected" *ngIf="status.id===9 && items.facilityPriority===false">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusRejectedApprover' | translate}}</p>
                    </div>

                    <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===10 && items.facilityPriority===false">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label> {{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusApprovedApprover' | translate}} </p>
                    </div>
                    <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===9 && items.facilityPriority===true">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusRejectedPropWork' | translate}}</p>
                    </div>

                    <!-- 3° circle  Facility- -->
                    <div class="col-xs-2 o-steps__step" *ngIf="status.id===5 && items.facilityPriority===true">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label class="js-txt5">{{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p class="js-txt6">{{'AccessRequestConfirmationPortal.statusPendingApprover' | translate}}</p>
                    </div>

                    <div class="col-xs-2 o-steps__step" *ngIf="status.id===6 && items.facilityPriority===false">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label class="js-txt5">{{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p class="js-txt6">{{'AccessRequestConfirmationPortal.statusPendingPropWork' | translate}}</p>
                    </div>

                    <div class="col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id===7 && items.facilityPriority===true">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusApprovedApprover' | translate}} </p>
                    </div>

                    <div class="col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id===8 && items.facilityPriority===false">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusApprovedPropWork' | translate}} </p>
                    </div>
                    <div class="col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id===8 && items.facilityPriority===true">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusApprovedPropWork' | translate}} </p>
                    </div>

                    <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===10 && items.facilityPriority===false">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label> {{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusRejectedPropWork' | translate}}</p>
                    </div>
                    <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===10 && items.facilityPriority===true">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label> {{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p> {{'AccessRequestConfirmationPortal.siteApprover' | translate}}</p>
                    </div>
                    <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===9 && items.facilityPriority===true">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label>{{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.statusRejectedApprover' | translate}}</p>
                    </div>
                    <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===9 && items.facilityPriority===false">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label> {{'AccessRequestConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessRequestConfirmationPortal.PropWork' | translate}} </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-md-8 col-md-offset-2">
                  <div class="u-pt40 u-pb30 u-mb40 center c-results__box">
                    <h3> <span class="js-txt9">{{'AccessRequestConfirmationPortal.requestNumber' | translate}}:  </span> {{items.requestNumber}}</h3>
                    <p class="js-txt15">{{'AccessRequestConfirmationPortal.copySentEmail' | translate}}</p>
                  </div>
                </div>
              </div>
            </div>
            <p class="o-text o-text--big center js-txt16" *ngIf="buttonRedirect">{{'AccessRequestConfirmationPortal.trackRequest' | translate}}</p>
            <div class="row u-pt20">
              <div class="col-md-6 col-md-offset-3" *ngIf="buttonRedirect">
                <a class="btn btn--full btn--primary js-txt10" [routerLink]="['/incoming-access-requests']"> {{'AccessRequestConfirmationPortal.btnSeeAllRequest' | translate}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row u-pt60">
          <div class="col-md-12">
            <div class="hr"></div>
          </div>
          <div class="col-md-10 col-md-offset-1">
            <div class="o-reminder">
              <label class="o-title o-title--medium js-txt11">{{'AccessRequestConfirmationPortal.rememberCordinate' | translate}}</label>
              <div class="row u-pb20 u-mb20">
                <div class="col-md-12 elementDiv" >
                    <span class="elementSpan">{{'AccessRequestConfirmationPortal.contactCEP' | translate}}</span>
                </div>
              </div>
              <div class="row u-pt20">
                <div class="col-md-4 u-pt20">
                  <div class="row">
                    <div class="col-xs-3 col-md-12"><img src="../assets/img/mess-hall.png" alt="Mess Hall"></div>
                    <div class="col-xs-9 col-md-12">
                      <p> <strong class="js-txt12">{{'AccessRequestConfirmationPortal.canteen' | translate}} </strong><br><a title="{{'AccessRequestConfirmationPortal.sendMail' | translate}}" href="mailto:casino@bhpbilliton.com">{{'AccessRequestConfirmationPortal.contactMail' | translate}}</a></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 u-pt20">
                  <div class="row">
                    <div class="col-xs-3 col-md-12"><img src="../assets/img/transportation.png" alt="Transportation"></div>
                    <div class="col-xs-9 col-md-12">
                      <p> <strong class="js-txt13">{{'AccessRequestConfirmationPortal.transportation' | translate}} </strong><br><a title="{{'AccessRequestConfirmationPortal.sendMail' | translate}}" href="mailto:transportation@bhpbilliton.com">{{'AccessRequestConfirmationPortal.contactTransport' | translate}}</a></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 u-pt20">
                  <div class="row">
                    <div class="col-xs-3 col-md-12"><img src="../assets/img/accomodation.png" alt="Accomodation"></div>
                    <div class="col-xs-9 col-md-12">
                      <p> <strong class="js-txt14">{{'AccessRequestConfirmationPortal.accomodation' | translate}} </strong><br><a title="{{'AccessRequestConfirmationPortal.sendMail' | translate}}" href="mailto:casino@bhpbilliton.com">{{'AccessRequestConfirmationPortal.contactRoom' | translate}}</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
